import React, { useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { saveAs } from "file-saver";
import QRCode from "../containers/QRCode";

function BusinessInfoCard({ business }) {
  const [copyStatus, setCopyStatus] = useState(false);

  if (!business) return null;

  const onCopyText = () => {
    setCopyStatus(true);
    setTimeout(() => setCopyStatus(false), 2000);
  };

  const { name, address, rating, user_ratings_total, url } = business;

  const handleDownload = () => {
    const imageElement = document.querySelector(
      'img[alt="QR Code Générateur de lien Google Business Profile"]',
    );
    const imageUrl = imageElement.src;

    fetch(imageUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const file = new File([blob], "google_maps_qrcode.png", {
          type: "image/png",
        });
        saveAs(file);
      });
  };

  return (
    <div className="w-full max-w-2xl mx-auto p-4">
      <div className="relative search-container">
        <div className="flex justify-center items-center w-full max-w-2xl mx-auto mb-6">
          <div className="flex flex-col w-full mx-1">
            <div className="relative">
              <input
                type="text"
                className="bg-gray-50 border border-gray-300 text-gray-700 text-sm rounded-md shadow-almost-shadow focus:ring-blue-500 focus:border-blue-500 block w-full px-4 py-3"
                value={url}
                disabled
                readOnly
              />
              <CopyToClipboard text={url} onCopy={onCopyText}>
                <button className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-900 bg-white border border-gray-300 hover:bg-gray-100 rounded-lg py-2 px-3 inline-flex items-center">
                  {copyStatus ? (
                    <span className="inline-flex items-center text-zap-orange">
                      <svg
                        className="w-4 h-4 mr-1"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 16 12"
                      >
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M1 5.917L5.724 10.5 15 1.5"
                        />
                      </svg>
                      <span className="text-xs font-semibold">Copié</span>
                    </span>
                  ) : (
                    <span className="inline-flex items-center">
                      <svg
                        className="w-4 h-4 mr-1"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 18 20"
                      >
                        <path d="M16 1h-3.278A1.992 1.992 0 0 0 11 0H7a1.993 1.993 0 0 0-1.722 1H2a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2Zm-3 14H5a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2Zm0-4H5a1 1 0 0 1 0-2h8a1 1 0 1 1 0 2Zm0-5H5a1 1 0 0 1 0-2h2V2h4v2h2a1 1 0 1 1 0 2Z" />
                      </svg>
                      <span className="text-xs font-semibold">Copier URL</span>
                    </span>
                  )}
                </button>
              </CopyToClipboard>
            </div>
          </div>
        </div>

        <div className="flex justify-center items-center w-full h-xl max-w-2xl mx-auto">
          <div className="flex flex-col md:flex-row w-full p-4 bg-white border-1 border border-gray-200 rounded-md shadow-almost-shadow overflow-hidden relative">
            <div className="flex flex-col md:flex-row w-full">
              <div className="w-full md:w-1/2 pr-4 text-left">
                <h3 className="text-xl font-medium mt-5 mb-2 text-earth">
                  {name}
                </h3>
                <p className="text-base text-earth">{address}</p>
                <p className="mt-1 text-base text-earth">
                  Note moyenne : <span>{rating}</span>
                </p>
                <p className="mt-1 text-base text-earth">
                  Nombre total d'avis :{" "}
                  <span>{user_ratings_total}</span>
                </p>
                <button
                  onClick={handleDownload}
                  className="mt-4 text-sm font-semibold text-white bg-zap-orange hover:bg-orange-700 rounded-lg py-2 px-4 flex items-center justify-center"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-5 h-5 mr-2"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M9 8.25H7.5a2.25 2.25 0 0 0-2.25 2.25v9a2.25 2.25 0 0 0 2.25 2.25h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25H15M9 12l3 3m0 0 3-3m-3 3V2.25"
                    />
                  </svg>
                  Télécharger image
                </button>
              </div>
              <div className="w-full md:w-1/2 flex flex-col justify-center items-center mt-4 md:mt-0">
                <QRCode data={url} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BusinessInfoCard;
